var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19995 3C4.09538 3 3.19995 3.89543 3.19995 5V19C3.19995 20.1046 4.09538 21 5.19995 21H19.2C20.3045 21 21.2 20.1046 21.2 19V12H19.2V19H5.19995V5H12.2V3H5.19995ZM19.9279 4.70711C18.7563 3.53553 16.8568 3.53553 15.6852 4.70711L8.48158 11.9108C8.33471 12.0576 8.23722 12.2466 8.20264 12.4514L7.62812 15.8543C7.57423 16.1735 7.67817 16.499 7.90705 16.7279C8.13594 16.9568 8.46146 17.0607 8.78064 17.0069L12.1836 16.4323C12.3884 16.3978 12.5773 16.3003 12.7242 16.1534L19.9279 8.94975C21.0994 7.77817 21.0994 5.87868 19.9279 4.70711ZM17.0994 6.12132C17.49 5.7308 18.1231 5.7308 18.5137 6.12132C18.9042 6.51184 18.9042 7.14501 18.5137 7.53553L11.5358 14.5134L9.83431 14.8007L10.1216 13.0992L17.0994 6.12132Z",
    fill: "#FFFF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d546f004.svg";
export { ForwardRef as ReactComponent };